import React from 'react';

import {gt} from 'app/utils/i18n';

import {AutomationForm} from './ProcedureEditPage/ActiveEditableProcedureStep/EditableProcedureAutomationFooter';
import {StepAutomationTitle} from './structures';

import type {ProcedureAutomationStepType} from 'sweet-types/procedure/procedure-step';

type Props = {
  step: ProcedureAutomationStepType;
};

export function ViewableAutomation({step}: Props) {
  return (
    <div className="pb-4">
      <StepAutomationTitle className="mt-3" title={gt('Email Automation')} />
      <div className="card">
        <div className="card-body">
          <AutomationForm edit={false} automation={step.automation} />
        </div>
      </div>
    </div>
  );
}
